import React, {Component} from "react"
import {Badge} from "react-bootstrap"

const styleMap = {
  EMPTY: 'scheduled',
  UPLOADED: 'completed',
}

export const statusTextMap = {
  EMPTY: 'Scheduled',
  UPLOADED: 'Completed'
}

class CogoLandActivityStatusLabel extends Component {
  render() {

    const style = styleMap[this.props.status]

    return (
      <Badge pill bsStyle={style}>{statusTextMap[this.props.status]}</Badge>
    )
  }
}

export default CogoLandActivityStatusLabel



// WEBPACK FOOTER //
// ./src/routes/cogoland/component/CogoLandActivityStatusLabel.js